import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Datepicker from '../../../components/common/components/Datepicker';
import ModalWrapper from '../../../components/modalWrapper';
import moment from 'moment';

function ModalSelectPaymentDate({
  openModal,
  setOpenModal,
  onDateSelect,
  invoiceData,
}) {
  const { t } = useTranslation();
  const [date, setDate] = useState(null);

  function handleClose() {
    setOpenModal(false);
    setDate(null);
  }

  function handleSubmit() {
    if (date && onDateSelect) {
      const formattedDate = moment(date).format('YYYY-MM-DD');
      onDateSelect(formattedDate, invoiceData);
      handleClose();
    }
  }

  return (
    <ModalWrapper
      headerTitle={t('selectPaymentDate')}
      openModal={openModal}
      setModalWrapper={handleClose}
    >
      <div className="modal_container__body__text">
        {t('selectPaymentDateText')}
      </div>
      <div className="modal_container__body__dropdowns">
        <Datepicker
          date={date}
          setDate={(newValue) => setDate(newValue)}
          disabled={false}
          type={'reset-dp-modal'}
        />
      </div>
      <div
        className={
          date !== null ? 'button_red_small' : 'button_red_smal_disabled'
        }
        style={{ width: 'unset'}}
        onClick={
          date !== null
            ? handleSubmit
            : (e) => e.stopPropagation()
        }
      >
        {t('confirm')}
      </div>
    </ModalWrapper>
  );
}

export default ModalSelectPaymentDate;
